import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import './Layout.scss';
import NavbarHeaderNew from "components/Header/NavbarHeaderNew";
import NavbarHeader from "components/Header/NavbarHeader";
interface LayoutProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ className = '', contentClassName = '', children }) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  const [openedIndex, setOpenedIndex] = React.useState<number>(-1);

  const [mobileMenuVisible, setMobileMenuVisible] = React.useState(false);
  const [isShowMenuMobile, setIsShowMenuMobile] = React.useState(false);

  const [isActive, setIsActive] = React.useState(false);
  const [isActiveUser, setIsActiveUser] = React.useState(false);

  const [isShrinked, setIsShrinked] = useState(false);
  const [isTypeColor, setIsTypeColor] = React.useState(false);

  const handleLogout = () => {
    // Xóa token và user info
    localStorage.removeItem("token")
    localStorage.removeItem("user")
    
    // Redirect về trang login
    window.location.href = "/login"
  }

  const navItems = [
    {
      id: 'qlkh',
      label: 'Quản lý khách hàng',
      href: '/',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-users w-5 h-5"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx={9} cy={7} r={4} />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
    },
    {
      id: 'lsgd',
      label: 'Lịch sử giao dịch',
      href: '/lich-su',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-coins w-5 h-5"
        >
          <circle cx={8} cy={8} r={6} />
          <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
          <path d="M7 6h1v4" />
          <path d="m16.71 13.88.7.71-2.82 2.82" />
        </svg>
      ),
    },
    // {
    //   id: 'qlgt',
    //   label: 'Quản lý gói token',
    //   href: '/goi-token',
    //   icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width={24}
    //       height={24}
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth={2}
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       className="lucide lucide-package w-5 h-5"
    //     >
    //       <path d="m7.5 4.27 9 5.15" />
    //       <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
    //       <path d="m3.3 7 8.7 5 8.7-5" />
    //       <path d="M12 22V12" />
    //     </svg>
    //   ),
    // },
    {
      id: 'affiliate',
      label: 'Đối tác',
      href: '/doi-tac',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-package w-5 h-5"
        >
          <path d="m7.5 4.27 9 5.15" />
          <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
          <path d="m3.3 7 8.7 5 8.7-5" />
          <path d="M12 22V12" />
        </svg>
      ),
    },
    // {
    //   id: 'service',
    //   label: 'Dịch vụ',
    //   href: '/dich-vu',
    //   icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width={24}
    //       height={24}
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth={2}
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       className="lucide lucide-package w-5 h-5"
    //     >
    //       <path d="m7.5 4.27 9 5.15" />
    //       <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
    //       <path d="m3.3 7 8.7 5 8.7-5" />
    //       <path d="M12 22V12" />
    //     </svg>
    //   ),
    // },
    {
      id: 'qlcb',
      label: 'Quản lý Chatbot',
      href: '/chatbot',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-bot w-5 h-5"
        >
          <path d="M12 8V4H8" />
          <rect width={16} height={12} x={4} y={8} rx={2} />
          <path d="M2 14h2" />
          <path d="M20 14h2" />
          <path d="M15 13v2" />
          <path d="M9 13v2" />
        </svg>
      ),
    },
    {
      id: 'dvchat',
      label: 'Dịch vụ Chat',
      href: '/dich-vu-chat',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-settings w-5 h-5"
        >
          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
          <circle cx={12} cy={12} r={3} />
        </svg>
      ),
    },
    {
      id: 'dmdv',
      label: 'Danh mục bot',
      href: '/danh-muc-dich-vu',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-settings w-5 h-5"
        >
          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
          <circle cx={12} cy={12} r={3} />
        </svg>
      ),
    },
    {
      id: 'package',
      label: 'Gói dịch vụ',
      href: '/goi-dich-vu',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-package w-5 h-5"
        >
          <path d="m7.5 4.27 9 5.15" />
          <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
          <path d="m3.3 7 8.7 5 8.7-5" />
          <path d="M12 22V12" />
        </svg>
      ),
    },
    // {
    //   id: 'tkchat',
    //   label: 'Thống kê Chat',
    //   href: '/thong-ke-chat',
    //   icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width={24}
    //       height={24}
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth={2}
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       className="lucide lucide-bar-chart3 w-5 h-5"
    //     >
    //       <path d="M3 3v18h18" />
    //       <path d="M18 17V9" />
    //       <path d="M13 17V5" />
    //       <path d="M8 17v-3" />
    //     </svg>
    //   ),
    // },
    // {
    //   id: 'cbnd',
    //   label: 'Cảnh báo người dùng',
    //   href: '/canh-bao',
    //   icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width={24}
    //       height={24}
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth={2}
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       className="lucide lucide-message-square-warning w-5 h-5"
    //     >
    //       <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    //       <path d="M12 7v2" />
    //       <path d="M12 13h.01" />
    //     </svg>
    //   ),
    // },
    // {
    //   id: 'muatoken',
    //   label: 'Mua token',
    //   href: '/mua-token',
    //   icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width={24}
    //       height={24}
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth={2}
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       className="lucide lucide-shopping-cart w-5 h-5"
    //     >
    //       <circle cx={8} cy={21} r={1} />
    //       <circle cx={19} cy={21} r={1} />
    //       <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
    //     </svg>
    //   ),
    // },
  ];

  // trong component Header
  const location = useLocation();

  // tìm item active dựa trên path hiện tại
  const activeNavItem = navItems.find(item => item.href === location.pathname) || {};

  const toggleNavbar = () => {
    const body = document.body;
    body.classList.toggle("navbar-shrinked"); // Thêm hoặc xóa class tự động
    setIsShrinked(!isShrinked);
  };

  const toggleTypeColor = () => {
    const body = document.body;
    body.classList.toggle("theme-dark"); // Thêm hoặc xóa class tự động
    setIsTypeColor(!isTypeColor);
  };

  return (
    <>
      <div className="min-h-screen bg-slate-50">
        <div className="flex h-screen overflow-hidden">
          <aside
            style={{ background: 'linear-gradient(to bottom, #0f172a, #1e293b)' }}
            //className="-translate-x-full fixed inset-y-0 left-0 z-50 w-64 bg-gradient-to-b from-slate-900 to-slate-800 text-white transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static"
            className={`fixed inset-y-0 left-0 z-50 w-64 bg-gradient-to-b from-slate-900 to-slate-800 text-white transform transition-transform duration-300 ease-in-out
              ${isShowMenuMobile ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 lg:static`
            }
          >
            <div className="flex flex-col h-full">
              <div className="flex items-center justify-between p-6 border-b border-slate-700">
                <div className="flex items-center gap-3">
                  <div
                    style={{ background: 'linear-gradient(to bottom right, #3b82f6, #06b6d4)' }}
                    className="bg-gradient-to-br from-blue-500 to-cyan-500 p-2 rounded-lg"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-coins w-6 h-6"
                    >
                      <circle cx={8} cy={8} r={6} />
                      <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
                      <path d="M7 6h1v4" />
                      <path d="m16.71 13.88.7.71-2.82 2.82" />
                    </svg>
                  </div>
                  <div>
                    <h1 className="text-lg font-bold">Quản trị viên</h1>
                    <p className="text-xs text-slate-400">Hệ thống Token</p>
                  </div>
                </div>
                <button
                  onClick={() => { isShowMenuMobile ? setIsShowMenuMobile(false) : setIsShowMenuMobile(true) }}
                  className="lg:hidden text-slate-400 hover:text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-x w-6 h-6"
                  >
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                  </svg>
                </button>
              </div>
              <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
                {navItems.map((item) => (
                  <NavLink
                    key={item.id}
                    to={item.href}
                    //className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all bg-blue-500 text-white shadow-lg"
                    className={({ isActive }) =>
                      `w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all ${isActive
                        ? 'bg-blue-500 text-white shadow-lg'
                        : 'text-slate-300 hover:bg-slate-700 hover:text-white'
                      }`
                    }
                  >
                    {item.icon}
                    <span className="font-medium">{item.label}</span>
                  </NavLink>
                ))}
                {/* <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all bg-blue-500 text-white shadow-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-users w-5 h-5"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx={9} cy={7} r={4} />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                  <span className="font-medium">Quản lý khách hàng</span>
                </button>
                <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all text-slate-300 hover:bg-slate-700 hover:text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-coins w-5 h-5"
                  >
                    <circle cx={8} cy={8} r={6} />
                    <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
                    <path d="M7 6h1v4" />
                    <path d="m16.71 13.88.7.71-2.82 2.82" />
                  </svg>
                  <span className="font-medium">Lịch sử giao dịch</span>
                </button>
                <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all text-slate-300 hover:bg-slate-700 hover:text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-package w-5 h-5"
                  >
                    <path d="m7.5 4.27 9 5.15" />
                    <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
                    <path d="m3.3 7 8.7 5 8.7-5" />
                    <path d="M12 22V12" />
                  </svg>
                  <span className="font-medium">Quản lý gói token</span>
                </button>
                <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all text-slate-300 hover:bg-slate-700 hover:text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-bot w-5 h-5"
                  >
                    <path d="M12 8V4H8" />
                    <rect width={16} height={12} x={4} y={8} rx={2} />
                    <path d="M2 14h2" />
                    <path d="M20 14h2" />
                    <path d="M15 13v2" />
                    <path d="M9 13v2" />
                  </svg>
                  <span className="font-medium">Quản lý Chatbot</span>
                </button>
                <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all text-slate-300 hover:bg-slate-700 hover:text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-settings w-5 h-5"
                  >
                    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                    <circle cx={12} cy={12} r={3} />
                  </svg>
                  <span className="font-medium">Dịch vụ Chat</span>
                </button>
                <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all text-slate-300 hover:bg-slate-700 hover:text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-bar-chart3 w-5 h-5"
                  >
                    <path d="M3 3v18h18" />
                    <path d="M18 17V9" />
                    <path d="M13 17V5" />
                    <path d="M8 17v-3" />
                  </svg>
                  <span className="font-medium">Thống kê Chat</span>
                </button>
                <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all text-slate-300 hover:bg-slate-700 hover:text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-message-square-warning w-5 h-5"
                  >
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    <path d="M12 7v2" />
                    <path d="M12 13h.01" />
                  </svg>
                  <span className="font-medium">Cảnh báo người dùng</span>
                </button>
                <button className="w-full flex items-center gap-3 px-3 py-3 rounded-lg transition-all text-slate-300 hover:bg-slate-700 hover:text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-shopping-cart w-5 h-5"
                  >
                    <circle cx={8} cy={21} r={1} />
                    <circle cx={19} cy={21} r={1} />
                    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                  </svg>
                  <span className="font-medium">Mua token</span>
                </button> */}
              </nav>
              <div className="p-4 border-t border-slate-700">
                <div className="bg-slate-700 rounded-lg p-4 mb-3">
                  <p className="text-xs text-slate-400 mb-1">Đăng nhập bằng</p>
                  <p className="font-semibold text-sm">System Administrator</p>
                  <p className="text-xs text-slate-400">admin@gmail.com</p>
                  <div className="mt-2">
                    <span className="inline-block px-2 py-1 text-xs rounded-full bg-yellow-500 text-yellow-950">
                      Quản trị cấp cao
                    </span>
                  </div>
                </div>
                <button onClick={handleLogout} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-slate-300 hover:bg-red-500 hover:text-white transition-all">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-log-out w-5 h-5"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1={21} x2={9} y1={12} y2={12} />
                  </svg>
                  <span className="font-medium">Đăng xuất</span>
                </button>
              </div>
            </div>
          </aside>
          <div className="flex-1 flex flex-col overflow-hidden">
            <header className="bg-white shadow-sm border-b border-slate-200 p-4 lg:p-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <button
                    className="lg:hidden text-slate-600 hover:text-slate-900"
                    onClick={() => { isShowMenuMobile ? setIsShowMenuMobile(false) : setIsShowMenuMobile(true) }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-menu w-6 h-6"
                    >
                      <line x1={4} x2={20} y1={12} y2={12} />
                      <line x1={4} x2={20} y1={6} y2={6} />
                      <line x1={4} x2={20} y1={18} y2={18} />
                    </svg>
                  </button>
                  <div>
                    <h2 className="text-2xl font-bold text-slate-900">
                      {activeNavItem.label || "Quản lý khách hàng"}
                    </h2>
                    <p className="text-sm text-slate-600">
                      Quản lý và giám sát hệ thống token
                    </p>
                  </div>
                </div>
              </div>
            </header>
            <main className="flex-1 overflow-auto p-4 lg:p-6">
              {children}
            </main>
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout;

// Simple implementation of useState for SSR or testing (not for production)
function useState<T>(initialValue: T): [T, (value: T) => void] {
  let value = initialValue;
  const setValue = (newValue: T) => {
    value = newValue;
  };
  return [value, setValue];
}

